import React from 'react'
import { Button, Row, Col, Form } from '@themesberg/react-bootstrap'

import GamesList from '../GamesList'

const AddGamesToSubCategory = ({
  unRestrictedItems,
  limit,
  page,
  setLimit,
  setPage,
  totalPages,
  addGame,
  selectedGames,
  removeGame,
  addRestrictedGames,
  search,
  setSearch,
  getProviderName,
  subCategoryName
}) => {
  return (
    <>
      <Row>

      <Col sm={8}>
                <h3>Add Games: {subCategoryName?.EN}</h3>
              </Col>
        
        <Col className='text-right'>
          <Button
            variant='outline-success'
            className='f-right'
            disabled={selectedGames.count === 0}
            onClick={addRestrictedGames}
          >
            Submit
          </Button>
        </Col>

        <Col xs={4}>
          <Form.Label>
            <h5>Games you add will appear here</h5>
          </Form.Label>
        </Col>
      </Row>

      <GamesList
        disablePagination
        games={selectedGames}
        hasActions
        hasRemoveGamesAction
        removeGame={removeGame}
        getProviderName={getProviderName}
      />

      <Row className='mt-3'>
        {/* <Col xs={4}>
          <Form.Label>
            <h5>Unrestricted Games</h5>
          </Form.Label>
        </Col> */}
        <Col className='d-flex'>
          <Form.Control
            type='search'
            name='search'
            placeholder='Search Game'
            style={{ width: '270px' }}
            size='sm'
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
      </Row>

      <GamesList
        limit={limit}
        setLimit={setLimit}
        page={page}
        setPage={setPage}
        games={unRestrictedItems}
        totalPages={totalPages}
        hasActions
        hasAddGamesAction
        addGame={addGame}
        getProviderName={getProviderName}
        sr
      />
    </>
  )
}

export default AddGamesToSubCategory
